import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import type { TaskView } from '../../../api/backlog';

interface BacklogCardProps {
  task: TaskView;
  onClick: (task: TaskView) => void;
}

const BacklogCard: React.FC<BacklogCardProps> = ({ task, onClick }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: task.id });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const isOverdue = task.dueDate && new Date(task.dueDate) < new Date() && task.status !== 'DONE' && task.status !== 'CANCELLED';

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className={`backlog-card backlog-card--${task.priority} ${isDragging ? 'dragging' : ''}`}
      onClick={() => onClick(task)}
    >
      <div className="backlog-card-title">{task.title}</div>
      <div className="backlog-card-meta">
        <span className={`backlog-priority-badge backlog-priority-badge--${task.priority}`}>
          {task.priority}
        </span>
        {task.labels.map((label) => (
          <span key={label} className="backlog-label-chip">{label}</span>
        ))}
        {task.dueDate && (
          <span className={`backlog-due-date ${isOverdue ? 'overdue' : ''}`}>
            {task.dueDate}
          </span>
        )}
      </div>
    </div>
  );
};

export default BacklogCard;
